import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBsZobAdAGyZSgkfLwAnb2lYGSeSRL_46E",
  authDomain: "confluence-d2844.firebaseapp.com",
  projectId: "confluence-d2844",
  storageBucket: "confluence-d2844.appspot.com",
  messagingSenderId: "137913208340",
  appId: "1:137913208340:web:36b956ec9530f736bd6101"
};

export const app = initializeApp(firebaseConfig);